import { NavigationGuard } from "vue-router";
import { authStore } from "@/store/auth";
import { authService } from "@/app/services/AuthService";

/**
 * トークンの有効性チェック。
 * 未ログインでトークン自体が無ければそのまま通過。
 * @param to
 * @param _from
 * @param next
 */
export const checkToken: NavigationGuard = async (to, _from, next) => {
  // トークン持ってるかチェック
  const isExistToken = authStore.existToken;
  if (!isExistToken) {
    // トークンが無ければそのまま通過
    next();
    return;
  }

  const isTokenExpired = authStore.tokenIsExpired();
  // 切れてたらウェルカムページ
  if (isTokenExpired) {
    await authStore.logout();
    next({
      name: "Welcome"
    });
    return;
  }

  const isTokenExpiredInNear = authStore.tokenIsNearExpired();
  // もうすぐ有効期限が切れる場合
  if (isTokenExpiredInNear) {
    // リフレッシュ
    const isOk = await authService.refreshToken();
    if (!isOk) {
      next({
        name: "Welcome"
      });
      return;
    }
  }

  next();
};
